export function lookUpPlayerName(person, pick) {
    const row = person.summary?.find(({ name }) => name === pick);
    let playerName = row?.name ?? pick;

    if (person.name === "Timmy") {
        switch (pick) {
            case "Ludvig Åberg":
                playerName = "Aberg";
                break;
            case "Robert MacIntyre":
                playerName = "Robert MacIntyrem";
                break;
            case "Matt McCarty":
                playerName = "Matt McCarthy";
                break;
            case "Cameron Smith":
                playerName = "Cam Smith";
                break;
            case "Wyndham Clark":
                playerName = "Wyndham";
                break;
            default:
        }
    }
    return playerName;
}
